/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyTemporaryClosedDate,
  PharmacyTemporaryClosedDateFromJSON,
  PharmacyTemporaryClosedDateFromJSONTyped,
  PharmacyTemporaryClosedDateToJSON,
} from "./";

export const PutTemporaryClosedDatesRequestBodyTypename = "PutTemporaryClosedDatesRequestBody" as const;

/**
 *
 * @export
 * @interface PutTemporaryClosedDatesRequestBody
 */
export interface PutTemporaryClosedDatesRequestBody {
  /**
   *
   * @type {Array<PharmacyTemporaryClosedDate>}
   * @memberof PutTemporaryClosedDatesRequestBody
   */
  temporaryClosedDates: Array<PharmacyTemporaryClosedDate>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutTemporaryClosedDatesRequestBody
   */
  readonly __typename?: string;
}

export function PutTemporaryClosedDatesRequestBodyFromJSON(json: any): PutTemporaryClosedDatesRequestBody {
  return PutTemporaryClosedDatesRequestBodyFromJSONTyped(json, false);
}

export function PutTemporaryClosedDatesRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutTemporaryClosedDatesRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutTemporaryClosedDatesRequestBodyTypename,

    temporaryClosedDates: (json["temporary_closed_dates"] as Array<any>).map(PharmacyTemporaryClosedDateFromJSON),
  };
}

export function PutTemporaryClosedDatesRequestBodyToJSON(object?: PutTemporaryClosedDatesRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    temporary_closed_dates: (value.temporaryClosedDates as Array<any>).map(PharmacyTemporaryClosedDateToJSON),
  };
}
